"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./SuperHero.scss");
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _useStyles = _interopRequireDefault(require("../../utils/hooks/useStyles"));
var _useVideo = require("../../utils/hooks/useVideo");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _SuperHeroMethods = require("./SuperHeroMethods");
var _checkForCTAClassName = require("../../utils/checkForCTAClassName");
var _useContainerHeight = _interopRequireDefault(require("../../utils/hooks/useContainerHeight"));
var _useScreenSize = require("../../utils/hooks/useScreenSize");
var _useCompareContainerHeights = _interopRequireDefault(require("./useCompareContainerHeights"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// TODO - change name of this component once we have a name
const SuperHero = _ref => {
  let {
    contentfulIdSuperHero,
    content,
    ContentComponent,
    paddingClass,
    isPageHeader = false,
    lazyLoad
  } = _ref;
  const {
    contentfulId,
    video,
    thumbnail,
    image,
    focusedImage,
    eyebrow,
    header,
    isLongSubheader,
    subHeader,
    text,
    cta,
    ctas,
    theme,
    Link,
    contentSide = "right",
    variant = "variant_1",
    transcript,
    transcriptText,
    closeTranscript,
    dataPoints,
    videoProgress,
    setVideoProgress,
    override = false,
    superHeroAnimation
  } = content;
  const [transcriptVisable, setTranscriptVisable] = (0, _react.useState)(false);
  const {
    mouse
  } = (0, _useMouse.default)();
  const {
    width
  } = (0, _useScreenSize.useScreenSize)();
  const {
    containerHeight: contentContainerHeight
  } = (0, _useContainerHeight.default)("luna-super-hero__content-wrapper", width);
  const {
    containerHeight: imageWrapperHeight
  } = (0, _useContainerHeight.default)("luna-super-hero__image-wrapper", width);
  const {
    alignTop
  } = (0, _useCompareContainerHeights.default)(contentContainerHeight, imageWrapperHeight);
  const themes = (0, _checkForThemeProps.checkForThemeProps)(theme);
  const {
    backgroundColor,
    color,
    ctaOne,
    ctaTwo
  } = (0, _useStyles.default)(themes);
  (0, _checkForCTAClassName.checkForCTAClassName)(ctas, themes);
  const {
    hovering,
    modalDeployed,
    playing,
    deployModal,
    hideModal,
    setHovering,
    togglePlaying
  } = (0, _useVideo.useVideo)(false, false, false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _SuperHeroMethods.renderVariantsOneToSeven)(contentfulIdSuperHero, contentfulId, variant, contentSide, focusedImage, _SuperHeroMethods.imageSizes, eyebrow, header, isLongSubheader, subHeader, text, cta, ctas, theme, Link, mouse, color, backgroundColor, paddingClass, modalDeployed, image, video, thumbnail, hovering, playing, deployModal, hideModal, setHovering, togglePlaying, content, ContentComponent, transcriptVisable, setTranscriptVisable, transcript, transcriptText, closeTranscript, alignTop, videoProgress, setVideoProgress, override, superHeroAnimation, lazyLoad, isPageHeader), (0, _SuperHeroMethods.renderVariantEightToTen)(contentfulIdSuperHero, contentfulId, variant, ContentComponent, contentSide, focusedImage, _SuperHeroMethods.imageSizes, eyebrow, header, isLongSubheader, subHeader, text, cta, ctas, theme, Link, mouse, color, backgroundColor, dataPoints, superHeroAnimation, lazyLoad, isPageHeader));
};
var _default = SuperHero;
exports.default = _default;